import { ILocation } from "../../../../utils/AnnounceInterfaces";
import { Map } from "../../../Map/Map";
import React from "react";

export function StepThree(props: {
    values: ILocation;
    handleChange: (longitude: number, latitude: number) => void;
    handleNext: () => void;
    autoGeolocate: boolean;
    startLongitude?: number;
    startLatitude?: number;
    searchTypeName?: string;
}) {
    const [geolocationError, setGeolocationError] = React.useState<string | null>(null);

    React.useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
        
        // Check if geolocation is available
        if (props.autoGeolocate && !navigator.geolocation) {
            setGeolocationError("Geolocation is not supported by your browser");
        }
    }, [props.autoGeolocate]);

    if (geolocationError) {
        return (
            <div>
                <p>{geolocationError}</p>
                <p>Please manually select a location on the map.</p>
                <Map
                    setLocation={true}
                    autoGeolocate={false} // Disable auto-geolocation
                    handleChange={props.handleChange}
                    handleNext={props.handleNext}
                    startZoom={12}
                    startLongitude={props.startLongitude}
                    startLatitude={props.startLatitude}
                />
            </div>
        );
    }

    return (
        <Map
            setLocation={true}
            autoGeolocate={props.autoGeolocate}
            handleChange={props.handleChange}
            handleNext={props.handleNext}
            startZoom={12}
            startLongitude={props.startLongitude}
            startLatitude={props.startLatitude}
        />
    );
}